import React, { useState } from 'react';
import { motion } from 'framer-motion';
import PurchaseModal from './PurchaseModal';
import { Gift } from 'lucide-react';

interface GiftCardProps {
  id: string;
  name: string;
  description: string;
  imageUrl: string;
  price: number;
  pixKey: string;
  isPurchased: boolean;
  purchaseCount: number;
  onPurchase: (id: string, name: string, phone: string, message: string) => Promise<void>;
}

const GiftCard: React.FC<GiftCardProps> = ({ 
  id, 
  name, 
  description, 
  imageUrl, 
  price, 
  pixKey,
  purchaseCount,
  onPurchase
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <motion.div 
        className="bg-white rounded-lg shadow-md overflow-hidden"
        whileHover={{ y: -5, transition: { duration: 0.2 } }}
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        <div className="h-48 overflow-hidden bg-gray-50">
          <img 
            src={imageUrl} 
            alt={name} 
            className="w-full h-full object-contain"
          />
        </div>
        
        <div className="p-4">
          <h3 className="text-lg font-playfair font-medium text-wedding-blue-800 mb-1">{name}</h3>
          <p className="text-sm text-gray-600 mb-3">{description}</p>
          
          <div className="flex justify-between items-center">
            <div>
              <p className="font-medium text-wedding-beige-800">
                R$ {price.toFixed(2)}
              </p>
              {purchaseCount > 0 && (
                <p className="text-sm text-gray-500">
                  Presenteado {purchaseCount}x
                </p>
              )}
            </div>
            
            <button
              onClick={() => setShowModal(true)}
              className="px-3 py-1.5 bg-wedding-blue-600 text-white rounded-md text-sm hover:bg-wedding-blue-700 transition-colors flex items-center gap-2"
            >
              <Gift size={16} />
              Presentear via Pix
            </button>
          </div>
        </div>
      </motion.div>
      
      {showModal && (
        <PurchaseModal 
          giftName={name}
          giftPrice={price}
          pixKey={pixKey}
          onClose={() => setShowModal(false)}
          onSubmit={(purchaserName, phone, message) => 
            onPurchase(id, purchaserName, phone, message)
              .then(() => setShowModal(false))
          }
        />
      )}
    </>
  );
};

export default GiftCard;